import ee, { STORAGE_KEYS as s } from "./storage-manager.js";
import { logger as E } from "../../shared-lib/index.js";
const Kt = {
  _l: function (e, o = !1) {
    let t = !1;
    try {
      if (localStorage && localStorage.getItem)
        try {
          localStorage.setItem(s.ft.Qc, "true"),
            localStorage.getItem(s.ft.Qc) &&
              (localStorage.removeItem(s.ft.Qc), (t = !0));
        } catch (e) {
          if (
            !(
              e instanceof Error &&
              ("QuotaExceededError" === e.name ||
                "NS_ERROR_DOM_QUOTA_REACHED" === e.name) &&
              localStorage.length > 0
            )
          )
            throw e;
          t = !0;
        }
    } catch (e) {
      E.info("Local Storage not supported!");
    }
    const r = Kt.Uc(),
      a = new ee.Jc(e, r && !o, t);
    let n;
    return (n = t ? new ee.Wc(e) : new ee.Xc()), new ee(a, n);
  },
  Uc: function () {
    return (
      navigator.cookieEnabled ||
      ("cookie" in document &&
        (document.cookie.length > 0 ||
          (document.cookie = "test").indexOf.call(document.cookie, "test") >
            -1))
    );
  },
};
export default Kt;
